import MyAlertsApiConsumer from '@trackif/api-js';

// IE workaround for custom events
(function () {
    /* istanbul ignore if  */
    if ( typeof window.CustomEvent === "function" ) {
        // Returning, this is a good browser.
        return false;
    }

    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

function myAlertsService($q, userSummaryService, localStorageService, $window) {
    let myAlertsApi, summary, optout, alertSubmitted;
    const svOptoutKey = 'cars.save.vehicle.confirm.optout',
          clientIdProd = 'carscom';

    function initializeService() {
        const clientId = clientIdProd;
        alertSubmitted = false;
        optout = (localStorageService.getItem(svOptoutKey)) ? localStorageService.getItem(svOptoutKey) : false;
        myAlertsApi = new MyAlertsApiConsumer({clientId: clientId});
        return userSummaryService.ready().then((sum) => {
            summary = sum;
        });
    }

    function auth(email, meta) {
        let deferred, promise;

        deferred = $q.defer();
        promise = deferred.promise;

        /* istanbul ignore next */
        myAlertsApi.auth(email, meta, function (err, response) {
            if (err) {
                deferred.reject(err);
            }
            deferred.resolve(response);
        });
        return promise;
    }

    function track(product, meta) {
        let deferred, promise;
        deferred = $q.defer();
        promise = deferred.promise;

        if (!product) {
            deferred.reject("product url cannot be empty");
            return promise;
        }
        let item = {
            url: product,
            tags: ["product-discontinued", "custom-price-drop"],
            type: "product",
            meta: meta,
            triggers: [{
                name: "product_discontinued",
                options: {}
            }, {
                name: "product_price_change",
                options: {
                    conditions: [{
                        name: "price_drop",
                        threshold: 100
                    }]
                }
            }],
            notifications: ["email"]
        };
        /* istanbul ignore next */
        myAlertsApi.trackItem(item, function (err) {
            if (err) {
                deferred.reject(err);
            }
            deferred.resolve();
        });
        return promise;
    }

    function unTrack(product, meta) {
        let deferred, promise;
        deferred = $q.defer();
        promise = deferred.promise;

        if (!product) {
            deferred.reject();
            return promise;
        }
        let item = {
            url: product,
            tags: [],
            type: "product",
            meta: meta,
            triggers: [],
            notifications: []
        };
        /* istanbul ignore next */
        // TODO:write unit test
        myAlertsApi.untrackItem(item, function (err) {
            if (err) {
                deferred.reject(err);
            }
            deferred.resolve();
        });
        return promise;
    }

    function createTracker(email, vehicle) {
        if (vehicle && vehicle.listingId && vehicle.url && vehicle.state) {
            const trackingEvent = new CustomEvent('priceDropAlertSuccess');
            alertSubmitted = true;
            vehicle.meta = {
                listingId: vehicle.listingId,
                url: vehicle.url,
                state: vehicle.state,
                zipcode: vehicle.zipcode
            };
            localStorageService.setItem('cars.localStorage.signalFormTrackingData', JSON.stringify({
                email: email
            }));
            $window.document.body.dispatchEvent(trackingEvent);
            return trackerCommand(service.track, email, vehicle);
        }
        let deferred;
        deferred = $q.defer();
        deferred.reject("vehicle object is malformed, cannot extract metadata");
        return deferred.promise;
    }

    function removeTracker(email, url) {
        return trackerCommand(service.unTrack, email, {url: url, meta: {}});
    }



    function trackerCommand(command, email, vehicle) {
        let deferred, promise;
        deferred = $q.defer();
        promise = deferred.promise;
        if (!email || !vehicle.url || !vehicle.meta) {
            deferred.reject("email, url, and metadata are required");
            return promise;
        }
        service.auth(email, {})
            .then(function () {
                return command(vehicle.url, vehicle.meta);
            })
            .then(function () {
                deferred.resolve(true);
            })
            .catch(function (err) {
                deferred.reject(err);
            });
        return promise;
    }


    function getOptoutState() {
        return optout;
    }

    function setOptoutState() {
        optout = !optout;
        localStorageService.setItem(svOptoutKey, optout);
    }

    function isAlertSubmitted() {
        return alertSubmitted;
    }

    function setAlertSubmitted(newState) {
        alertSubmitted = !!(newState);
    }

    let service = {
        initializeService,
        auth,
        track,
        unTrack,
        createTracker,
        removeTracker,
        getOptoutState,
        setOptoutState,
        isAlertSubmitted,
        setAlertSubmitted
    };

    return service;
}

myAlertsService.$inject = [
    '$q',
    'userSummaryService',
    'localStorageService',
    '$window'
];

export default myAlertsService;
